var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { b2cAddressesApi } from '../api/b2c/addresses';
import { addressesApi } from '../api/common/addresses';
import { isLoggedIn } from '../utils/user';
const AddressesContext = React.createContext(null);
const AddressesProvider = ({ children, isB2B }) => {
    const [addresses, setAddresses] = useState(null);
    const [addressFormMode, setAddressFormMode] = useState(null);
    const [editableAddress, setEditableAddress] = useState(null);
    const [defaultAddress, setDefaultAddress] = useState(null);
    const [defaultCheckoutAddress, setDefaultCheckoutAddress] = useState(null);
    const getAddresses = (options) => {
        if (!isLoggedIn()) {
            return Promise.reject(new Error('user is not logged in'));
        }
        return addressesApi.getAddresses(isB2B, options).then((data) => {
            setAddresses(data);
            setDefaultAddress(data.response.find((adr) => adr.isDefault) || null);
            setDefaultCheckoutAddress(data.response.find((adr) => adr.instantCheckoutDefault) || null);
            return data;
        });
    };
    const changeDefault = (newDefId, newDefAdr) => __awaiter(void 0, void 0, void 0, function* () {
        const newDefault = newDefAdr ||
            (addresses === null || addresses === void 0 ? void 0 : addresses.response.find((adr) => adr.addrIdentifier === newDefId));
        let currentDefAdr = defaultAddress;
        if (!currentDefAdr && !isB2B) {
            yield b2cAddressesApi.getDefaultAddress().then(({ data }) => {
                currentDefAdr =
                    data.addresses.address.find((adr) => adr.isDefault) || null;
            });
        }
        return addressesApi
            .changeDefaultAddress(isB2B, Object.assign(Object.assign({}, newDefault), { isDefault: true }), 
        // catch scenarios where customer has only one address that is NOT set as default
        isB2B || !currentDefAdr
            ? null
            : Object.assign(Object.assign({}, currentDefAdr), { isDefault: false }))
            .then((defaultAdr) => {
            setDefaultAddress(defaultAdr);
            return defaultAdr;
        });
    });
    return (React.createElement(AddressesContext.Provider, { value: {
            addresses,
            isB2B,
            addressFormMode,
            editableAddress,
            defaultAddress,
            defaultCheckoutAddress,
            setAddressFormMode,
            setEditableAddress,
            getAddresses,
            changeDefault,
        } }, children));
};
export { AddressesProvider, AddressesContext };
